module.exports = __webpack_public_path__ + "img/mainPicture.de12e06d.png";